<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between">
      <div class="d-flex align-items-center" style="gap: 20px">
        <el-input
            size="small" clearable
            style="width: 240px"
            @change="filterListReport"
            v-model="keyword"
            placeholder="Tên lớp"
        />
        <el-date-picker
            @change="filterListReport"
            size="small"
            style="width: 240px"
            v-model="date"
            type="month"
            format="MM-yyyy"
            value-format="yyyy-MM-dd"
            placeholder="Chọn tháng"
        >
        </el-date-picker>
      </div>
      <el-button size="small" class="btn btn-warning font-weight-bolder" @click="exportExcel">
        <i class="fa far fa-cloud-download p-0 mr-2"></i> Report chỉ số
      </el-button>
    </div>
    <div class="card-body">
      <div class="example-preview table-responsive overflow-auto mt-3">
        <table class="table table-hover table-bordered table-vertical-center b-table" style="text-align: center"  >
          <thead>
            <tr>
              <th scope="col" class="min-w-100px">STT</th>
              <th scope="col" class="min-w-100px">Mã lớp</th>
              <th scope="col" class="min-w-100px ">Tên lớp</th>
              <th scope="col" class="min-w-100px">Mã GV</th>
              <th scope="col" class="min-w-100px">Tên GV</th>
              <th scope="col" class="min-w-100px">Ngày KG </th>
              <th scope="col" class="min-w-100px">Ngày KT</th>
              <th scope="col" class="min-w-100px">Tỉ lệ hoàn thành BTNV</th>
              <th scope="col" class="min-w-100px">Tỷ lệ chuyên cần</th>
              <th scope="col" class="min-w-100px">Tỷ lệ hài lòng</th>
              <th scope="col" class="min-w-100px">Tỷ lệ pass đầu ra</th>
            </tr>
          </thead>
          <tbody>
          <template v-for="(item, index) in listReport">
            <tr>
              <td>{{ getIndexPaginate(page, index, 20) }}</td>
              <td>{{ item.id }}</td>
              <td align="left">{{ item.className }}</td>
              <td>{{ item.teacherId }}</td>
              <td  align="left">{{ item.teacherName }}</td>
              <td>{{ item.startDate }}</td>
              <td>{{ item.endDate }}</td>
              <td>{{ item.percentHomework   }}</td>
              <td>{{ item.percentAttendance  }}</td>
              <td>{{ item.percentGood  }}</td>
              <td>{{ item.percentPass }}</td>
            </tr>
          </template>
          <tr v-if="listReport.length === 0 && !loading">
            <td colspan="9" class="event-title no-data">Chưa có dữ liệu</td>
          </tr>
          </tbody>
        </table>
        <div class="edu-paginate mx-auto text-center mt-10 mb-5"
             style="display: flex; justify-content: center; align-items: center; height: 50px">
          <paginate
              v-model="page"
              :page-count="lastPage"
              :page-range="3"
              :margin-pages="1"
              :click-handler="clickCallback"
              :prev-text="'Trước'"
              :next-text="'Sau'"
              :container-class="'pagination b-pagination'"
              :pageLinkClass="'page-link'"
              :next-link-class="'next-link-item'"
              :prev-link-class="'prev-link-item'"
              :prev-class="'page-link'"
              :next-class="'page-link'"
              :page-class="'page-item'"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {EXPORT_REPORT_STATS, GET_LIST_REPORT_STATS} from "@/core/services/store/course/classes.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {ReportStatModel} from "@/view/pages/classes/model/ReportStats";
import {exportExcel} from "@/core/filters";

export default {
  name: 'ReportStats',
  data() {
    return {
      keyword: null,
      date: null,
      loading: false,
      listReport: [],
      page: 1,
      lastPage: 1,
      total: 0,
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý dạy học", route: ""},
      {title: "Report chỉ số"},
    ]);
    this.getListReport()
  },
  methods: {
    clickCallback(obj) {
      this.page = obj;
      this.getListReport()
    },
    filterListReport() {
      this.page = 1
      this.getListReport()
    },
    getListReport() {
      this.loading = true
      const payload = {
        page: this.page,
        keyword: this.keyword,
        date: this.date,
      }
      this.$store.dispatch(GET_LIST_REPORT_STATS, payload).then(res => {
        if (!res.error) {
          this.listReport = res.data.map(item => {
            return new ReportStatModel(item)
          }) ?? []
          this.page = res.pagination.current_page
          this.lastPage = res.pagination.last_page
          this.total = res.pagination.total
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => {
        this.loading = false
      })
    },
    exportExcel() {
      this.is_export_excel = true
      const HEADER_ROW_EXPORT_REPORT_STATS = [
        {
          key: 'stt',
          value: 'STT',
        },
        {
          key: 'teacherId',
          value: 'Mã GV',
        },
        {
          key: 'teacherName',
          value: 'Tên GV',
        },
        {
          key: 'startDate',
          value: 'Ngày KG',
        },
        {
          key: 'endDate',
          value: 'Ngày KT',
        },
        {
          key: 'percentHomework',
          value: 'Tỉ lệ hoàn thành BTNV',
        },
        {
          key: 'percentAttendance',
          value: 'Tỷ lệ chuyên cần',
        },
        {
          key: 'percentGood',
          value: 'Tỷ lệ hài lòng',
        },
        {
          key: 'percentPass',
          value: 'Tỷ lệ pass đầu ra',
        },
      ]
      const payload = this.$route.query
      this.$store.dispatch(EXPORT_REPORT_STATS, payload).then((res) => {
        this.is_export_excel = false
        if (res.error) {
          this.$bvToast.toast(res.data.message, {
            title: 'Export excel',
            variant: 'danger',
            solid: true
          });
        } else {
          const data = res.data.map(item => {
            return new ReportStatModel(item)
          })
          exportExcel(HEADER_ROW_EXPORT_REPORT_STATS, data, "Danh sách report chỉ số.xlsx", true)
        }
      });
    },
  }
}
</script>